import blog1 from '../assets/images/blog/01.jpg'
import blog2 from '../assets/images/blog/02.jpg'
import blog3 from '../assets/images/blog/03.jpg'
import blog4 from '../assets/images/blog/04.jpg'
import blog5 from '../assets/images/blog/05.jpg'
import blog6 from '../assets/images/blog/06.jpg'
import blog7 from '../assets/images/blog/07.jpg'
import blog8 from '../assets/images/blog/08.jpg'
import blog9 from '../assets/images/blog/09.jpg'

export const blogsService = [
    {
        id: 1,
        title: 'Easily connect to doctor and make a treatment',
        description: "This is required when, for example, the final text is not yet available. Dummy text is also known as fill text. It is said that song composers of the past used dummy texts as lyrics when writing melodies in order to have a 'ready-made' text to sing with the melody. Dummy texts have been in use by typesetters since the 16th century Due to its widespread use as filler text for layouts, non-readability is of great importance: human perception is tuned to recognize certain patterns and repetitions in texts.For this reason, dummy text usually consists of a more or less random series of words or syllables.",
        image: blog1,
        createdAt: new Date(),
        updatedAt: new Date(),
        readTime: '5 min',
        user: {
            id: 1,
            name: 'John Doe',
            email: 'johndoe@gmail.com',
        }
    },
    {
        id: 2,
        title: 'Lock downs lead to fewer people seeking medical care',
        description: "This is required when, for example, the final text is not yet available. Dummy text is also known as fill text. It is said that song composers of the past used dummy texts as lyrics when writing melodies in order to have a 'ready-made' text to sing with the melody. Dummy texts have been in use by typesetters since the 16th century Due to its widespread use as filler text for layouts, non-readability is of great importance: human perception is tuned to recognize certain patterns and repetitions in texts.For this reason, dummy text usually consists of a more or less random series of words or syllables.",
        image: blog2,
        createdAt: new Date(),
        updatedAt: new Date(),
        readTime: '5 min',
        user: {
            id: 1,
            name: 'John Doe',
            email: 'johndoe@gmail.com',
        }
    },
    {
        id: 3,
        title: 'medicine research course for doctors',
        description: "This is required when, for example, the final text is not yet available. Dummy text is also known as fill text. It is said that song composers of the past used dummy texts as lyrics when writing melodies in order to have a 'ready-made' text to sing with the melody. Dummy texts have been in use by typesetters since the 16th century Due to its widespread use as filler text for layouts, non-readability is of great importance: human perception is tuned to recognize certain patterns and repetitions in texts.For this reason, dummy text usually consists of a more or less random series of words or syllables.",
        image: blog3,
        createdAt: new Date(),
        updatedAt: new Date(),
        readTime: '5 min',
        user: {
            id: 1,
            name: 'John Doe',
            email: 'johndoe@gmail.com',
        }
    }
    , {
        id: 4,
        title: 'Comparing Nitrogen And Mechanical Freezers',
        description: "This is required when, for example, the final text is not yet available. Dummy text is also known as fill text. It is said that song composers of the past used dummy texts as lyrics when writing melodies in order to have a 'ready-made' text to sing with the melody. Dummy texts have been in use by typesetters since the 16th century Due to its widespread use as filler text for layouts, non-readability is of great importance: human perception is tuned to recognize certain patterns and repetitions in texts.For this reason, dummy text usually consists of a more or less random series of words or syllables.",
        image: blog4,
        createdAt: new Date(),
        updatedAt: new Date(),
        readTime: '5 min',
        user: {
            id: 1,
            name: 'John Doe',
            email: 'johndoe@gmail.com',
        }
    }
    , {
        id: 5,
        title: 'It Is Very Important To Wear Proper Clothing',
        description: "This is required when, for example, the final text is not yet available. Dummy text is also known as fill text. It is said that song composers of the past used dummy texts as lyrics when writing melodies in order to have a 'ready-made' text to sing with the melody. Dummy texts have been in use by typesetters since the 16th century Due to its widespread use as filler text for layouts, non-readability is of great importance: human perception is tuned to recognize certain patterns and repetitions in texts.For this reason, dummy text usually consists of a more or less random series of words or syllables.",
        image: blog5,
        createdAt: new Date(),
        updatedAt: new Date(),
        readTime: '5 min',
        user: {
            id: 1,
            name: 'John Doe',
            email: 'johndoe@gmail.com',
        }
    },
    {
        id: 6,
        title: 'Hollowed-Out Faces More Cuts Amid Virus',
        description: "This is required when, for example, the final text is not yet available. Dummy text is also known as fill text. It is said that song composers of the past used dummy texts as lyrics when writing melodies in order to have a 'ready-made' text to sing with the melody. Dummy texts have been in use by typesetters since the 16th century Due to its widespread use as filler text for layouts, non-readability is of great importance: human perception is tuned to recognize certain patterns and repetitions in texts.For this reason, dummy text usually consists of a more or less random series of words or syllables.",
        image: blog6,
        createdAt: new Date(),
        updatedAt: new Date(),
        readTime: '5 min',
        user: {
            id: 1,
            name: 'John Doe',
            email: 'johndoe@gmail.com',
        }
    },
    {
        id: 7,
        title: 'Comparing Nitrogen And Mechanical Freezers',
        description: "This is required when, for example, the final text is not yet available. Dummy text is also known as fill text. It is said that song composers of the past used dummy texts as lyrics when writing melodies in order to have a 'ready-made' text to sing with the melody. Dummy texts have been in use by typesetters since the 16th century Due to its widespread use as filler text for layouts, non-readability is of great importance: human perception is tuned to recognize certain patterns and repetitions in texts.For this reason, dummy text usually consists of a more or less random series of words or syllables.",
        image: blog7,
        createdAt: new Date(),
        updatedAt: new Date(),
        readTime: '5 min',
        user: {
            id: 1,
            name: 'John Doe',
            email: 'johndoe@gmail.com',
        }
    }
    , {
        id: 8,
        title: 'It Is Very Important To Wear Proper Clothing',
        description: "This is required when, for example, the final text is not yet available. Dummy text is also known as fill text. It is said that song composers of the past used dummy texts as lyrics when writing melodies in order to have a 'ready-made' text to sing with the melody. Dummy texts have been in use by typesetters since the 16th century Due to its widespread use as filler text for layouts, non-readability is of great importance: human perception is tuned to recognize certain patterns and repetitions in texts.For this reason, dummy text usually consists of a more or less random series of words or syllables.",
        image: blog8,
        createdAt: new Date(),
        updatedAt: new Date(),
        readTime: '5 min',
        user: {
            id: 1,
            name: 'John Doe',
            email: 'johndoe@gmail.com',
        }
    },
    {
        id: 9,
        title: 'Hollowed-Out Faces More Cuts Amid Virus',
        description: "This is required when, for example, the final text is not yet available. Dummy text is also known as fill text. It is said that song composers of the past used dummy texts as lyrics when writing melodies in order to have a 'ready-made' text to sing with the melody. Dummy texts have been in use by typesetters since the 16th century Due to its widespread use as filler text for layouts, non-readability is of great importance: human perception is tuned to recognize certain patterns and repetitions in texts.For this reason, dummy text usually consists of a more or less random series of words or syllables.",
        image: blog9,
        createdAt: new Date(),
        updatedAt: new Date(),
        readTime: '5 min',
        user: {
            id: 1,
            name: 'John Doe',
            email: 'johndoe@gmail.com',
        }
    }
]
